import React, { useState } from "react"
import DataTable from "react-data-table-component"
import { Col, Container, Row } from "reactstrap"
import FilterInTable from "../../../../Manage/FilterInTable"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const ReturnManage = () => {
  const tabs = ["All", "In Progress", "Pending", "Completed"]
  const [activeTab, setActiveTab] = useState("All")

  const data = [
    {
      returnId: "R12345",
      orderNo: "O98765",
      customer: "John Doe",
      productPrice: 30,
      reasonForReturn: "Defective",
      comment: 'The product is defective, its not working properly',
      status: "Pending",
      action: "Approve/Reject",
    },
    {
      returnId: "R12345",
      orderNo: "O98765",
      customer: "John Doe",
      productPrice: 30,
      reasonForReturn: "Damaged",
      comment: 'The product is defective, its not working properly',
      status: "Pending",
      action: "Review",
    },
    {
      returnId: "R12345",
      orderNo: "O98765",
      customer: "John Doe",
      productPrice: 30,
      reasonForReturn: "Not as described",
      comment: 'The product is defective, its not working properly',
      status: "Pending",
      action: "View Details",
    },
  ]

  const columns = [
    {
      name: "Return ID",
      selector: (row) => row.returnId,
      sortable: true,
    },
    {
      name: "Order No",
      selector: (row) => row.orderNo,
      sortable: true,
    },
    {
      name: "Customer",
      selector: (row) => row.customer,
      sortable: true,
    },
    {
      name: "Product Price",
      cell: (row) => <span>${row.productPrice}</span>,
      sortable: true,
    },
    {
      name: "Reason For Return",
      selector: (row) => row.reasonForReturn,
      sortable: true,
    },
    {
      name: "Comment",
      selector: (row) => row.comment,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => {
        const action = row.action

        if (action === "Approve/Reject") {
          return (
            <div>
              <button
                onClick={() => handleApprove(row.returnId)}
                style={{
                  marginRight: "5px",
                  // backgroundColor: "green",
                  // color: "white",
                  border: "none",
                  borderRadius: "3px",
                  padding: "5px 10px",
                }}
              >
                Approve
              </button>
              <button
                onClick={() => handleReject(row.returnId)}
                style={{
                  // backgroundColor: "red",
                  // color: "white",
                  border: "none",
                  borderRadius: "3px",
                  padding: "5px 10px",
                }}
              >
                Reject
              </button>
            </div>
          )
        } else if (action === "Review") {
          return (
            <button
              onClick={() => handleReview(row.returnId)}
              style={{
                // backgroundColor: "orange",
                // color: "white",
                border: "none",
                borderRadius: "3px",
                padding: "5px 10px",
              }}
            >
              Review
            </button>
          )
        } else if (action === "View Details") {
          return (
            <button
              onClick={() => handleViewDetails(row.returnId)}
              style={{
                // backgroundColor: "blue",
                // color: "white",
                border: "none",
                borderRadius: "3px",
                padding: "5px 10px",
              }}
            >
              View Details
            </button>
          )
        }

        return null
      },
    },
  ]

  const handleApprove = (id) => {
    console.log(`Approved return with ID: ${id}`)
  }

  const handleReject = (id) => {
    console.log(`Rejected return with ID: ${id}`)
  }
  
  const handleViewDetails = (id) => {
    console.log(`Rejected return with ID: ${id}`)
  }



  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F2F2F2",
        fontSize: "0.938rem",
        fontWeight: "500",
        color: "#1A2425",
        textAlign: "center",
      },
    },
  }

  return (
    <Container fluid>
      <h4 className="fw-semibold my-3">Return Manage</h4>

      <Row className="flex-nowrap overflow-x-auto text-nowrap">
        {tabs.map((tab, index) => (
          <Col key={index} className="text-center">
            <div
              style={{
                backgroundColor: activeTab === tab ? "#FBBD34" : "#ffffff",
                color: activeTab === tab ? "#ffffff" : "#1A2425",
                paddingBlock: "1rem",
                fontWeight: 500,
                fontSize: "1.25rem",
                cursor: "pointer",
                transition: "color 0.3s ease, background-color 0.3s ease",
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          </Col>
        ))}
      </Row>

      <Row className="my-3">
        <Col xs="12" xl='3'>
          <div className="rounded border border-black bg-white p-3">
            <Row className="g-0">
              <Col style={{ fontWeight: 500, fontSize: "1.25rem" }}>Returns completed:</Col>
              <Col xs="1" style={{ color: "#EC7426", fontSize: "1.25rem", fontWeight: 600 }}>
                1
              </Col>
            </Row>
            <Row className="g-0">
              <Col style={{ fontWeight: 500, fontSize: "1.25rem" }}>Returns in progress:</Col>
              <Col xs="1" style={{ color: "#EC7426", fontSize: "1.25rem", fontWeight: 600 }}>
                1
              </Col>
            </Row>
            <Row className="g-0">
              <Col style={{ fontWeight: 500, fontSize: "1.25rem" }}>Returns in pending:</Col>
              <Col xs="1" style={{ color: "#EC7426", fontSize: "1.25rem", fontWeight: 600 }}>
                3
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Container fluid className="g-0 bg-white rounded p-3 d-flex flex-column gap-2">
        <FilterInTable componentName="Orders Returns and Refunds" />
        <DatatableComponent columns={columns} data={data} type='gray' />
      </Container>
    </Container>
  )
}

export default ReturnManage
